import moment, { Moment } from 'moment'
import React from 'react'
import { compose } from 'recompose'

import { DEFAULT_DATE_FORMAT } from 'constants/date'

import { withRegisterService, withRegisterServiceProps } from 'services/legacy/register'

import { Select } from 'components'
import { SelectProps } from 'components/Select/Select'

import i18n from 'translations'

import withInfiniteDropdownHelpers, {
  withInfiniteDropdownHelpersProps,
} from '../../legacy/InfiniteDropdowns/withInfiniteDropdown'
import { DropdownProps } from '../InfiniteDropdownsModel'

export type RegisterChildDropdownProps = withInfiniteDropdownHelpersProps
  & withRegisterServiceProps
  & SelectProps
  & DropdownProps
  & {
    date?: Date | Moment | string | number
  }

const RegisterChildDropdown: React.FC<RegisterChildDropdownProps> = ({
  date,
  extraFields,
  groups,
  infiniteDropdownHelpers,
  onChange,
  placeholder,
  registerActions,
  registerSelectors,
  value,
  ...rest
}) => {
  const listAction = ({ newPage, newSearchPhrase, result }) => {
    const criteria = registerSelectors.getCriteria({
      date: moment(date).format(DEFAULT_DATE_FORMAT),
      present: 1,
      search: newSearchPhrase,
    })

    return registerActions.dropdownList({
      onSuccess: (response) => infiniteDropdownHelpers.handleLoadMoreElementsOnSuccess({
        extraFields,
        newPage,
        newSearchPhrase,
        response,
        result,
      }),
      onlyData: true,
      params: {
        criteria,
        groups,
        page: newPage,
      },
    })
  }

  return (
    <Select
      {...infiniteDropdownHelpers.getSelectRestParams({ onChange, value, ...rest })}
      loadOptions={infiniteDropdownHelpers.handleLoadMoreElementsV2({ listAction })}
      placeholder={placeholder || i18n.t('global:Children')}
      searchable
      withAvatars
    />
  )
}

const enhance = compose(
  withRegisterService,
  withInfiniteDropdownHelpers,
)

export default enhance(RegisterChildDropdown)
